import { FunctionComponent, useState } from 'react'
import { Modal } from 'components/core/modal'
import { Box, TextField, Typography, Button } from '@material-ui/core'
import { ErrorText } from './ErrorText'
import { BackendUser } from 'common/types'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

//@ts-ignore
import { useTheme } from 'styled-components'
import { Logo } from 'components/page/logo'

interface ChangePasswordModalProps {
  vDetails: BackendUser
  onSubmit: Function
  show: boolean
  setShowChangePassword?: Function
  setError: Function
  password: string
  setPassword: Function
  passwordValid: boolean
  setPasswordValid: Function
  onClose: Function
  passwordChange: boolean
  setPasswordChange: Function
  currentPassword: string
  setCurrentPassword: Function
  handleErrorMessage: Function
  passwordReset?: boolean
  confirmPassword: string 
  setConfirmPassword: Function
  confirmPasswordValid: boolean
  setConfirmPasswordValid: Function
  onCurrentPasswordChange?: Function
  onPasswordChange: Function
  onConfirmPasswordChange: Function
}

export const ChangePasswordModal: FunctionComponent<ChangePasswordModalProps> = ({
  onSubmit,
  show,
  setError,
  password,
  setPassword,
  passwordValid,
  setPasswordValid,
  onClose,
  currentPassword,
  setCurrentPassword,
  handleErrorMessage,
  passwordReset,
  confirmPassword,
  setConfirmPassword,
  confirmPasswordValid,
  setConfirmPasswordValid,
  onCurrentPasswordChange,
  onPasswordChange,
  onConfirmPasswordChange
}) => {
  const theme = useTheme()
  

  return (
    //@ts-ignore
    <Modal
      showCancel
      title={<Logo noBorder bright size="small" />}
      show={show}
      onClose={onClose}
      noBorder
      margin="2em"
      radius="1em"
    >
      <Box display="flex" justifyContent="center">
        <Box width="95%" textAlign="center" display="flex" flexDirection="column">
          <Typography component="span" variant="h6">
            <Box textAlign="left" color={theme.colors.accent1} fontWeight="bold">
              Create A New Password
            </Box>
          </Typography>
          {!passwordReset && (
            <Box m="1.5em 0">
              <TextField
                value={currentPassword}
                type="password"
                onChange={e => onCurrentPasswordChange(e)}
                variant="outlined"
                placeholder="Enter current password"
                fullWidth
              />
            </Box>
          )}
          <Box m="1.5em 0">
            <TextField
              value={password}
              type="password"
              onChange={e => onPasswordChange(e)}
              variant="outlined"
              placeholder="Enter new password"
              fullWidth
            />
          </Box>
          {!passwordValid && password && (
            <Typography component="span" variant="body1">
              <Box lineHeight="1em" color={theme.colors.error} textAlign="justify">
                Password does not meet the minimum requirements.
                <br /> <br /> Password must contain:-
                <br /> <br /> &emsp; 1.&emsp; Minimum eight (8) characters
                <br /> <br /> &emsp; 2.&emsp; One(1) Uppercase character
                <br /> <br /> &emsp; 3.&emsp; One(1) Lowercase character
                <br /> <br /> &emsp; 4.&emsp; One(1) Numerical digit
                <br /> <br /> &emsp; 5.&emsp; One(1) Special character (symbol)
              </Box>
            </Typography>
          )}
          <Box m="1.5em 0">
            <TextField
              type="password"
              onChange={e => {
                onConfirmPasswordChange(e)
                setError('')
              }}
              value={confirmPassword}
              variant="outlined"
              placeholder="Confirm new password"
              fullWidth
            />
          </Box>
          <ErrorText message={handleErrorMessage()} />
          {!confirmPasswordValid && confirmPassword && <ErrorText message="Passwords do not match" />}
          <Box borderRadius="2em" m="0.5em 0" bgcolor={theme.colors.supplementary1}>
            <Typography variant="body2" noWrap>
              <Box color={theme.colors.accent1} display="flex" padding="1em" mr="1em">
                <InfoOutlinedIcon style={{ marginRight: '0.23em' }} /> Your new password will be required on your next login
              </Box>
            </Typography>
          </Box>
          <Box m="2em 0 1em 0">
            {/* @ts-ignore */}
            <Button
              disabled={!(passwordValid && confirmPasswordValid)}
              onClick={() => {
                onSubmit()
                setCurrentPassword('')
                setConfirmPassword('')
                setPassword('')
                setPasswordValid(false)
                setConfirmPasswordValid(false)
              }}
              color="primary"
              variant="contained"
              fullWidth
            >
              <Typography>
                <Box fontWeight="900">Submit</Box>
              </Typography>
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
